import React from 'react'
import MdeEditorContainer from '../../../../Components/Miscellaneous/Editors/MdeEditor'

export default function MdeEditor() {
    return (
        <div className='page-body'>
            <MdeEditorContainer />
        </div>
    )
}
